export const DEFAULT_CURRENCY = "EUR";
export const BASE_COSTID = "o6fLThAWhaWW3uDaj";

export const costEnums = {
  BASE_COSTID,
  DUMMY_COSTID: "JpKrR3PggDfp8dnNP",
  DEFAULT_CURRENCY
};

export default costEnums;
